<template>
  <span>
    <v-btn
      v-if="showaudit && $userPermission.hasPermission('ROLE_ACCESO_AUDITORIA')"
      fab
      width="27"
      height="27"
      color="primary"
      elevation="0"
      class="btn_tippy vuetify--sacnite"
      :class="clase + (loading ? ' loading' : '')"
      :loading="loading"
      :title="$t('view.commons.audit')"
      @click="audit(claveComputed, descripcion)">
      <em class="fas fa-server" />
    </v-btn>
  </span>
</template>
<script>
export default {
  name: "ButtonAudit"
  , props: {
    clave: {
      default: null
      , type: Number
    }
    , clavestr: {
      default: null
      , type: String
    }
    , descripcion: {
      default: ""
      , type: String
    }
    , showaudit: {
      default: true
      , type: Boolean
    }
    , loading: {
      default: false
      , type: Boolean
    }
    , clase: {
      default: null
      , type: String
    }
    , table: {
      default: null
      , type: String
    }
  }
  , computed: {
    claveComputed() {
      return this.clavestr ? this.clavestr : this.clave;
    }
  }
  , methods: {
    audit(clave, descripcion) {
      if (this.table) {
        this.$emit("audit", clave, descripcion, this.table);
      } else {
        this.$emit("audit", clave, descripcion);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/datatable/ButtonAudit.vue